var _g;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgLinkedinSalesNavigator = function SvgLinkedinSalesNavigator(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#2056ce",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2056ce",
    fillRule: "nonzero",
    d: "M0 2560 l0 -2560 2560 0 2560 0 0 2560 0 2560 -2560 0 -2560 0 0 -2560z m2750 2099 c499 -45 949 -255 1300 -608 335 -336 529 -727 596 -1201 17 -121 20 -407 4 -525 -31 -242 -97 -466 -200 -673 -115 -232 -243 -406 -432 -587 -315 -304 -676 -484 -1123 -562 -152 -26 -520 -24 -675 5 -447 82 -817 275 -1130 591 -191 192 -325 385 -430 619 -124 277 -179 540 -180 849 0 466 139 891 414 1258 434 580 1144 899 1856 834z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2056ce",
    fillRule: "nonzero",
    d: "M2425 4314 c-16 -2 -66 -9 -110 -15 -470 -61 -929 -353 -1199 -762 -212 -324 -309 -692 -284 -1088 40 -658 474 -1251 1096 -1498 226 -90 368 -116 642 -116 243 0 350 16 547 81 589 192 1039 698 1163 1305 60 294 44 601 -47 884 -141 440 -442 797 -854 1015 -164 86 -326 140 -524 176 -78 14 -371 27 -430 18z m1125 -826 c-164 -381 -421 -916 -521 -1083 -115 -192 -171 -233 -617 -454 -231 -114 -790 -367 -796 -360 -7 7 288 651 395 864 129 255 195 364 261 431 87 90 350 233 818 446 412 188 475 216 479 212 2 -2 -6 -27 -19 -56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2056ce",
    fillRule: "nonzero",
    d: "M2525 2831 c-93 -24 -140 -66 -215 -191 -86 -144 -356 -700 -341 -700 22 0 578 274 694 342 87 51 142 100 170 152 17 33 22 58 22 126 0 68 -5 93 -22 126 -26 48 -92 110 -138 130 -42 17 -131 25 -170 15z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedinSalesNavigator, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin-sales-navigator.a62e6ec0.svg";
export { ForwardRef as ReactComponent };